import { render, staticRenderFns } from "./Wp_pdd_order_count_detail_page.vue?vue&type=template&id=556e2eda&scoped=true&"
import script from "./Wp_pdd_order_count_detail_page.vue?vue&type=script&lang=js&"
export * from "./Wp_pdd_order_count_detail_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556e2eda",
  null
  
)

export default component.exports